import { 
  Typography, 
  Box, 
  Divider, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer, 
  TableHead, 
  TableRow, 
  Paper 
} from '@mui/material';
import CodeBlock from '../../CodeBlock';

function RetractDdsEndpoint() {
  const restRequestExample = `{
   "ddsIdentifier":"97800d7b-bff7-4fd8-83a6-ea71a32fb710"
}`;

  const restResponseExample = `{
    "status": "success",
    "httpStatus": 200,
    "data": {
        "ddsIdentifier": "97800d7b-bff7-4fd8-83a6-ea71a32fb710",
        "message": "DDS retracted successfully"
    }
}`;

  return (
    <Box sx={{ textAlign: 'left', maxWidth: '900px' }}>
      <Typography variant="subtitle1" gutterBottom color="text.secondary">
        EUDR SOAP Version 1.3 - REST API Implementation
      </Typography>

      <Typography variant="body1" paragraph sx={{ my: 3 }}>
        Retract a Due Diligence Statement (DDS) through our REST API. Handles both cancellations (for submitted statements)
        and withdrawals (for available statements). Underlying SOAP service transactions are managed automatically.
      </Typography>

      <Typography variant="h5" gutterBottom sx={{ mt: 4, mb: 2 }} fontWeight="500">
        Base Endpoint
      </Typography>
      
      <CodeBlock code="DELETE /api/eudr/dds" />

      <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
        Request Requirements
      </Typography>
      <ul>
        <li>Valid API key in Authorization header</li>
        <li>DDS identifier (UUID, reference number, verification number)</li>
        <li>Retraction reason (WITHDRAWAL/CANCELLATION)</li>
      </ul>

      <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
        Retract Conditions
      </Typography>
      <TableContainer component={Paper} sx={{ mt: 1, mb: 3 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>DDS Status</TableCell>
              <TableCell>Action</TableCell>
              <TableCell>Time Constraint</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>SUBMITTED</TableCell>
              <TableCell>Cancel</TableCell>
              <TableCell>Within 24h of submission</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>AVAILABLE</TableCell>
              <TableCell>Withdraw</TableCell>
              <TableCell>Before amendment cutoff date</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Divider sx={{ my: 4 }} />

      <Typography variant="h5" gutterBottom sx={{ mb: 2 }} fontWeight="500">
        Error Responses
      </Typography>
      <TableContainer component={Paper} sx={{ mt: 1 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>HTTP Status</TableCell>
              <TableCell>Error Code</TableCell>
              <TableCell>Description</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>400</TableCell>
              <TableCell>INVALID_RETRACTION_STATE</TableCell>
              <TableCell>DDS not in retractable state</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>404</TableCell>
              <TableCell>DDS_NOT_FOUND</TableCell>
              <TableCell>UUID does not exist</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>409</TableCell>
              <TableCell>REFERENCED_IN_STATEMENT</TableCell>
              <TableCell>DDS used in other statements</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      <Divider sx={{ my: 4 }} />

      <Typography variant="h5" gutterBottom sx={{ mb: 2 }} fontWeight="500">
        Example Requests
      </Typography>

      <Typography variant="subtitle1" gutterBottom>
        Retract Request
      </Typography>
      <CodeBlock code={restRequestExample} />

      <Typography variant="subtitle1" gutterBottom sx={{ mt: 3 }}>
        Success Response
      </Typography>
      <CodeBlock code={restResponseExample} />

      <Typography variant="body2" color="text.secondary" sx={{ mt: 3 }}>
        Note: All requests require Bearer token authentication
      </Typography>
    </Box>
  );
}

export default RetractDdsEndpoint; 